import {
    TApplicantCallRequirement,
    TBankDetailsRequirement,
    TCreditAgreementRequirement,
    TFundingRequirementsResponse,
    TIdVerificationRequirement,
    TPersonalGuaranteeRequirement,
    TUploadBankEvidenceRequirement,
    TUploadGewerbescheinRequirement
} from './fundingRequirements.types';

export const BANK_DETAILS_FIXTURE: TBankDetailsRequirement = {
    type: 'bank_details',
    status: 'action_needed'
};

export const ID_VERIFICATION_FIXTURE: TIdVerificationRequirement = {
    type: 'id_verification',
    status: 'action_needed'
};

export const UPLOAD_GEWERBESCHEIN_FIXTURE: TUploadGewerbescheinRequirement = {
    type: 'upload_gewerbeschein',
    status: 'action_needed'
};

export const CREDIT_AGREEMENT_FIXTURE: TCreditAgreementRequirement = {
    type: 'credit_agreement',
    status: 'action_needed',
    document_id: 'd4e5f6a7-b8c9-0123-4567-89abcdef0123'
};

export const PERSONAL_GUARANTEE_FIXTURE: TPersonalGuaranteeRequirement = {
    type: 'personal_guarantee',
    status: 'action_needed',
    document_id: '1a2b3c4d-5e6f-7890-abcd-ef1234567890'
};

export const UPLOAD_BANK_EVIDENCE_FIXTURE: TUploadBankEvidenceRequirement = {
    type: 'upload_bank_evidence',
    status: 'action_needed'
};

export const APPLICANT_CALL_FIXTURE: TApplicantCallRequirement = {
    type: 'applicant_call',
    status: 'action_needed'
};

export const FUNDING_REQUIREMENTS_FIXTURE: TFundingRequirementsResponse = {
    data: {
        requirements: [
            BANK_DETAILS_FIXTURE,
            ID_VERIFICATION_FIXTURE,
            UPLOAD_GEWERBESCHEIN_FIXTURE,
            CREDIT_AGREEMENT_FIXTURE,
            PERSONAL_GUARANTEE_FIXTURE,
            UPLOAD_BANK_EVIDENCE_FIXTURE,
            APPLICANT_CALL_FIXTURE
        ],
        summary: {
            total: 7,
            action_needed: 7,
            completed: 0,
            all_complete: false
        }
    }
};
